import { COMPLIANCE_STATUS } from "../../constants/constant";

type DriverSummaryProps = {
  restDaysIn14: string;
  consecRestDays: string;
  kkDaysIn14: string;
  consecKKDays: string;
  kkd: boolean;
  style?:string;
  consecWorkStyle?:string;
  restStyle?:string;
  consecRestStyle?:string;
  workStyle?:string;
};

export default function DriverSummary({
  restDaysIn14,
  consecRestDays,
  kkDaysIn14,
  consecKKDays,
  kkd,
  style,
  consecWorkStyle,
  restStyle,
  consecRestStyle,
  workStyle,
}: DriverSummaryProps) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-y-6 gap-x-6 text-start text-sm">
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">
        Rests Days in 14<br />
        Total (Min 4)
      </p>

        <p
        className={` ${
      restStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : restStyle === COMPLIANCE_STATUS.upcoming || restStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        : restStyle === ''||COMPLIANCE_STATUS.compliant
          ? 'text-green'
          : 'text-gray-700'
     }`}
        >{restDaysIn14}</p>
      </div>
      <div className="flex flex-col">
        <p className={`font-medium text-textColorGray`}>Consec. (Min2)</p>
        <p
      className={` ${
      consecRestStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : consecRestStyle === COMPLIANCE_STATUS.upcoming || consecRestStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        : consecRestStyle === ''||COMPLIANCE_STATUS.compliant
          ? 'text-green'
          : 'text-gray-700'
     }`}
>
  {consecRestDays}
</p>

      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">KK'D Days in 14
      <br />
      Total (Max 10)	
        </p>
        <p 
        className={` ${
      workStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : workStyle === COMPLIANCE_STATUS.upcoming || workStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        : workStyle === ''||COMPLIANCE_STATUS.compliant
          ? 'text-green'
          : 'text-gray-700'
     }`}
        >{kkDaysIn14}</p>
      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">Consec. (Max6)</p>
        <p 
        className={` ${
      consecWorkStyle === COMPLIANCE_STATUS.expired
      ? 'text-red-700'
      : consecWorkStyle === COMPLIANCE_STATUS.upcoming || consecWorkStyle === COMPLIANCE_STATUS.current
        ? 'text-yellow-500'
        : consecWorkStyle === ''||COMPLIANCE_STATUS.compliant
          ? 'text-green'
          : 'text-gray-700'
     }`}
        >{consecKKDays}</p>
      </div>
      <div className="flex flex-col">
        <p className="font-medium text-textColorGray">KK'D</p>
        <p className="text-textColorGray">{kkd == true ? 'Y' : 'F'}</p>
      </div>
    </div>
  );
}
